<div class="small-header transition ">
  <div class="hpanel">
    <div class="panel-body">
      <!-- Breadcrumb -->
      <div id="hbreadcrumb" class="float-end" *ngIf="false">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">
              <span>Advisor Dashboard</span>
            </li>
          </ol>
        </nav>
      </div>
      <!-- Icon -->
      <div class="float-start me-3">
        <span class="fa fa-2x fa-tachometer mt-1 text-primary"></span>
      </div>
      <!-- Heading -->
      <div>
        <h2 class="fw-light mb-2">
          <span>ADVISOR DASHBOARD</span>
        </h2>
        <small>
          <span>Advisor Dashboard</span>
        </small>
      </div>
    </div>
  </div>
</div>

<div class="content">
  <div class="row">
    <div class="col-lg-12">
      <app-advisorop-panel [panelTitle]="'RMD'" [showFooter]="true">
        <panel-tools>
        </panel-tools>
        <panel-body>
          <app-rmd-tracker-advisor></app-rmd-tracker-advisor>
        </panel-body>
        <panel-footer>* * *</panel-footer>
      </app-advisorop-panel>
    </div>
  </div>
</div>
